export default class GroupInviteController {

    constructor($state, $stateParams, $ionicLoading, ApiGroups, $ionicPopup, $filter) {

        this.token = $stateParams.token;
        this.$ionicLoading = $ionicLoading;
        this.ApiGroups = ApiGroups;
        this.loading = [];
        this.$state = $state;
        this.translate = $filter('translate');
        this.$ionicPopup = $ionicPopup;
    }

    init() {
        this.showLoading();
        this.ApiGroups.getInfo(this.token).then((response) => {
            if (undefined !== response) {
                this.groupDetails = response;
            }
            this.hideLoading();
        });
    }

    showLoading() {
        this.loading.push(1);
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>'
        });
    }

    hideLoading() {
        this.loading.pop();
        if (this.loading.length === 0) {
            this.$ionicLoading.hide();
        }
    }

    accept() {
        this.showLoading();
        this.ApiGroups.acceptInvite(this.token, this.groupDetails.userExists).then((response) => {
            if(undefined !== response){
                this.showPopUp('GROUP_INVITATION_ACCEPTED');
            }
            this.hideLoading();
        });
    }

    decline() {
        this.showLoading();
        this.ApiGroups.declineInvite(this.token).then((response) => {
            if(undefined !== response){
                this.showPopUp('GROUP_INVITATION_DECLINED');
            }
            this.hideLoading();
        });
    }

    showPopUp(message) {

        this.$ionicPopup.alert({
            title: this.translate('INFO'),
            template: this.translate(message)
        }).then((res) => {
            this.$state.go('login');
        })
    }

}



/** WEBPACK FOOTER **
 ** ./src/app/components/extras/groupInvite.controller.js
 **/